export const PLANS = [
  {
    id: "business",
    name: "Business",
    tagline: "Everything to run your whole sales team.",
    recommended: true,
    featuresTitle: "You get:",
    features: [
      "Companies & contacts, up to 10 contact persons each",
      "Visual sales pipeline across 8 stages",
      "Interaction history: calls, emails, meetings and notes",
      "Task Management with priorities and due dates",
      "Dashboard & insights",
      "Prospect verification by managers",
      "Deals & closing, won or lost",
      "Send emails from IZSales",
      "Archive & restore companies",
    ],
    cta: { label: "Get started", href: "https://izsoftwares.com/contact-us" },
  },
  {
    id: "enterprise",
    name: "Enterprise",
    tagline: "Full oversight for larger organisations.",
    recommended: false,
    featuresTitle: "Everything in Business, plus:",
    features: [
      "Super Admin area for managing users",
      "Activity logs",
      "Delete interactions",
      "Full system oversight",
      "Call voice recording",
      "AI integration",
      "Stalled-lead alerts",
    ],
    cta: { label: "Get started", href: "https://izsoftwares.com/contact-us" },
  },
];